import React from 'react';

const ModernTabs = ({ 
  tabs = ["Home", "About", "Services", "Contact"],
  selectedTab,
  setSelectedTab,
  isHoveringTab,
  setIsHoveringTab
}) => {
    
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "48px", // Increased gap between tabs
      }}
    >
      {tabs.map((tab) => (
        <div
          key={tab}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            fontSize: "18px",
            fontWeight: selectedTab === tab ? "600" : "500",
            color: selectedTab === tab ? "#111827" : "#6b7280",
            cursor: "pointer",
            padding: "8px 4px",
            position: "relative",
            transition: "all 0.2s ease",
            letterSpacing: "0.01em",
          }}
          onClick={() => setSelectedTab(tab)}
          onMouseEnter={() => setIsHoveringTab(tab)}
          onMouseLeave={() => setIsHoveringTab(null)}
        >
          {tab}
          <div
            style={{
              position: "absolute",
              bottom: "-17px",
              left: "0",
              right: "0",
              height: "3px",
              background:
                selectedTab === tab
                  ? "linear-gradient(to right, #fdd34d, #f59e0b)"
                  : "linear-gradient(to right, #fdd34d, #f59e0b)",
              borderRadius: "2px 2px 0 0",
              opacity:
                selectedTab === tab ? 1 : isHoveringTab === tab ? 0.3 : 0,
              transform: `scaleX(${
                selectedTab === tab ? 1 : isHoveringTab === tab ? 0.6 : 0
              })`,
              transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
              boxShadow:
                selectedTab === tab
                  ? "0 0 8px rgba(253, 211, 77, 0.4)"
                  : "none",
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default ModernTabs;